import React, { useEffect } from "react";
import api from "../../Api/apiAxios";
import { useNavigate } from "react-router-dom";
import { MyContext } from "../../Context/MyContext";
import { Button, Modal } from "react-bootstrap";
import { Globe2 } from "react-bootstrap-icons";
import styles from "./Login.module.css";
import imagem2 from "../../Img/FundoLogin.png";
import { PedidosContext } from "../../Context/PedidosContext";

import Mensagem from "../../Components/Mensagem";

const Login = () => {
  
    const dadosContext = React.useContext(MyContext);
    const navigate = useNavigate();

    const [email, setEmail] = React.useState("");
    const [password, setPassword] = React.useState("");
    const [erro, setErro] = React.useState("");
    const [tipoMensagem, setTipoMensagem] = React.useState("");    
    const [loading, setLoading] = React.useState(false);

    const [showRecuperarSenha, setShowRecuperarSenha] = React.useState(false);
    const [stepRecuperar, setStepRecuperar] = React.useState("email"); // email | codigo | novaSenha
    const [emailRecuperacao, setEmailRecuperacao] = React.useState("");
    const [codigoRecuperacao, setCodigoRecuperacao] = React.useState("");
    const [novaSenha, setNovaSenha] = React.useState("");
    const [confirmarNovaSenha, setConfirmarNovaSenha] = React.useState("");
    const [loadingRecuperacao, setLoadingRecuperacao] = React.useState(false);
    const [usuarioRecuperacao, setUsuarioRecuperacao] = React.useState(null);
    const [recuperacaoMensagem, setRecuperacaoMensagem] = React.useState("");
    const [recuperacaoTipoMensagem, setRecuperacaoTipoMensagem] = React.useState("");
    const [hoverEsqueciSenha, setHoverEsqueciSenha] = React.useState(false);

    const { setIsAuth, getDistribuidores } = React.useContext(PedidosContext);

    useEffect(() => {
        if (dadosContext.tokenTimeout === true) {
            setErro("Token expirado, faça o login novamente");
            setTipoMensagem("danger");
            dadosContext.setTokenTimeout('');
        }
    }, [dadosContext])

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            validarLogin(event);
        }    
    }

    const validarLogin = async (ev) => {
      ev.preventDefault();

      if (!email) {
        setErro("Informe seu email.");
        setTipoMensagem("danger");
        return;
      }
      if (!password) {
        setErro("Informe sua senha.");
        setTipoMensagem("danger");
        return;
      }

      try {
        setLoading(true);
        setErro("");

        const { data: user } = await api.post("Usuario/login", { email, senha: password });

        if (!user || user.id === 0) {
          setErro("Usuário não encontrado, verifique suas informações!");
          setTipoMensagem("danger");
          setEmail("");
          setPassword("");
          dadosContext.setUsuario("");
          dadosContext.setToken("");
          setLoading(false);
          return;
        }

        dadosContext.setUsuario(user);

        const regUsuario = {
          Id: user.id, 
          DistribuidorId: user.distribuidorId || 0,
          ClienteId: user.clienteId || 0,
          Nome: user.nome || "",
          Email: user.email || email,
          Senha: password,
          Telefone: user.telefone || "",
          Celular: user.celular || "",
          Status: user.status ?? 1,
          TipoUsuario: user.tipoUsuario ?? 0,
          DataHoraCadastro: user.dataHoraCadastro ?? "0001-01-01T00:00:00",
          DataHoraUltimoAcesso: user.dataHoraUltimoAcesso ?? "0001-01-01T00:00:00",
          EnviarEmailCredenciais: user.enviarEmailCredenciais ?? 0,
          EnviarEmailFaturamento: user.enviarEmailFaturamento ?? 0,
          RestritoPermissoes: user.restritoPermissoes || null,
          Distribuidor: null,
        };

        const resp = await api.post("Token/", regUsuario, {
          headers: { "Content-Type": "application/json" },
          withCredentials: false,
        });

        window.localStorage.setItem("token", resp.data);
        window.localStorage.setItem("nivelUsuario", user.tipoUsuario);
        window.localStorage.setItem("distribuidorId", user.distribuidorId);
        window.localStorage.setItem("idUsuario", user.id);

        setIsAuth(true);
        getDistribuidores();
        navigate("/");
      } catch (error) {
        console.error(error);

        const payload = error?.response?.data;
        const msg =
          typeof payload === "string"
            ? payload
            : payload?.title ||
              (payload?.errors ? Object.values(payload.errors).flat().join(" | ") : null) ||
              error.message ||
              "Erro ao gerar token.";

        setErro(msg);
        setTipoMensagem("danger");
        setLoading(false);
      }
    };

    const abrirModalRecuperacao = () => {
      setStepRecuperar("email");
      setEmailRecuperacao(email || "");
      setCodigoRecuperacao("");
      setNovaSenha("");
      setConfirmarNovaSenha("");
      setUsuarioRecuperacao(null);
      setRecuperacaoMensagem("");
      setRecuperacaoTipoMensagem("");
      setShowRecuperarSenha(true);
    };

    const fecharModalRecuperacao = () => {
      setShowRecuperarSenha(false);
      setLoadingRecuperacao(false);
    };

    const handleEnviarEmailRecuperacao = async () => {
      if (!emailRecuperacao) {
        setRecuperacaoMensagem("Informe seu email.");
        setRecuperacaoTipoMensagem("danger");
        return;
      }

      try {
        setLoadingRecuperacao(true);
        setRecuperacaoMensagem("");

        const { data: usuario } = await api.get("Usuario/validar-email", {
          params: { email: emailRecuperacao },
        });

        if (!usuario || !usuario.id) {
          setRecuperacaoMensagem("Email não encontrado.");
          setRecuperacaoTipoMensagem("danger");
          return;
        }

        await api.get("Usuario/recuperacao-codigo", {
          params: { id: usuario.id },
        });

        setUsuarioRecuperacao(usuario);
        setRecuperacaoMensagem("Enviamos um e-mail com um código de 6 caracteres. Verifique sua caixa de entrada.");
        setRecuperacaoTipoMensagem("success");
        setStepRecuperar("codigo");
      } catch (error) {
        console.error(error);
        setRecuperacaoMensagem("Erro ao enviar e-mail de recuperação. Tente novamente em alguns instantes.");
        setRecuperacaoTipoMensagem("danger");
      } finally {
        setLoadingRecuperacao(false);
      }
    };

    const handleValidarCodigo = async () => {
      if (!codigoRecuperacao) {
        setRecuperacaoMensagem("Informe o código recebido por e-mail.");
        setRecuperacaoTipoMensagem("danger");
        return;
      }

      try {
        setLoadingRecuperacao(true);
        setRecuperacaoMensagem("");

        const { data: user } = await api.post("Usuario/login", {
          email: emailRecuperacao,
          senha: codigoRecuperacao,
        });

        if (!user || user.id === 0) {
          setRecuperacaoMensagem("Código inválido. Verifique e tente novamente.");
          setRecuperacaoTipoMensagem("danger");
          return;
        }

        setUsuarioRecuperacao(user);
        setStepRecuperar("novaSenha");
      } catch (error) {
        console.error(error);
        setRecuperacaoMensagem("Código inválido ou expirado. Verifique e tente novamente.");
        setRecuperacaoTipoMensagem("danger");
      } finally {
        setLoadingRecuperacao(false);
      }
    };

    const handleConfirmarNovaSenha = async () => {
      if (!novaSenha || !confirmarNovaSenha) {
        setRecuperacaoMensagem("Informe a nova senha e a confirmação.");
        setRecuperacaoTipoMensagem("danger");
        return;
      }

      if (novaSenha !== confirmarNovaSenha) {
        setRecuperacaoMensagem("As senhas não coincidem.");
        setRecuperacaoTipoMensagem("danger");
        return;
      }

      if (!usuarioRecuperacao || !usuarioRecuperacao.id) {
        setRecuperacaoMensagem("Usuário não carregado. Feche o modal e tente novamente.");
        setRecuperacaoTipoMensagem("danger");
        return;
      }

      try {
        setLoadingRecuperacao(true);
        setRecuperacaoMensagem("");

        const payload = {
          UsuarioId: usuarioRecuperacao.id,
          SenhaAtual: codigoRecuperacao,
          NovaSenha: novaSenha,
        };

        const ret = await api.put("Usuario/nova-senha", payload, {
          headers: { "Content-Type": "application/json" },
        });

        const responseText = (ret?.data || "").toString().toLowerCase();

        if (responseText.includes("sucesso")) {
          setRecuperacaoMensagem("Senha redefinida com sucesso! Você já pode fazer login com a nova senha.");
          setRecuperacaoTipoMensagem("success");
          setTimeout(() => {
            fecharModalRecuperacao();
          }, 2000);
        } else {
          setRecuperacaoMensagem("Ops, algo deu errado! Atualize a página e tente novamente...");
          setRecuperacaoTipoMensagem("danger");
        }
      } catch (error) {
        console.error(error);
        setRecuperacaoMensagem("Erro ao redefinir a senha. Tente novamente em alguns instantes.");
        setRecuperacaoTipoMensagem("danger");
      } finally {
        setLoadingRecuperacao(false);
      }
    };

    return(
        <form className={styles.form}>
            {erro && <Mensagem mensagem={erro} setMensagem={setErro} variant={tipoMensagem} width="25rem" />}

            <div className={styles.principal}>           
        
            <div className={styles.container}>
                <div className={styles.box}>

                    <br />   

                    <p style={{fontSize: '22px', fontWeight: 'normal'}}><Globe2 size={55} style={{marginRight: '10px', color: '#132350'}} /><strong style={{fontSize: '34px', fontWeight: 'bolder'}}>BMA</strong> Portal 3.3.5</p>

                    <input className={styles.inputs} type="email" name="email" placeholder="Email" 
                           autoComplete="email" value={email} 
                           onChange={({target}) => setEmail(target.value)} required
                    />
    
                    <input className={styles.inputs} type="password" name="senha" placeholder="Senha" 
                           autoComplete="current-password" value={password} 
                           onChange={({target}) => setPassword(target.value)} required
                           onKeyDown={handleKeyDown}
                    />
            
                    <Button onClick={validarLogin} className={styles.btn}>{!loading ? "ENTRAR" : "Aguarde..."}</Button>     
                    <p
                      style={{
                        fontSize: '12px',
                        color: hoverEsqueciSenha ? '#1e40af' : '#132350',
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        marginTop: '-2.3rem',
                        marginBottom: '8px',
                        width: '21rem',
                        textAlign: 'right',
                        transition: 'color 0.2s ease'
                      }}
                      onClick={abrirModalRecuperacao}
                      onMouseEnter={() => setHoverEsqueciSenha(true)}
                      onMouseLeave={() => setHoverEsqueciSenha(false)}
                    >
                      Esqueci minha senha
                    </p>
                    <p style={{fontSize: '16px', fontWeight: 'bolder', fontStyle: 'italic', color: '#191970'}}>Nós acreditamos em nossa parceria.</p> 
 
    
                </div>
            </div>

            <div className={styles.imagem}>
                <img src={imagem2} alt="Imagem" />
            </div>

          </div>

          <Modal show={showRecuperarSenha} onHide={fecharModalRecuperacao} centered>
            <Modal.Header closeButton>
              <Modal.Title>Recuperar senha</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ textAlign: 'center' }}>
              {recuperacaoMensagem && (
                <Mensagem
                  mensagem={recuperacaoMensagem}
                  setMensagem={setRecuperacaoMensagem}
                  variant={recuperacaoTipoMensagem}
                />
              )}

              {stepRecuperar === "email" && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <p>Informe o e-mail utilizado para acessar o portal.</p>
                  <input
                    className={styles.inputs}
                    type="email"
                    name="emailRecuperacao"
                    placeholder="Email"
                    autoComplete="email"
                    value={emailRecuperacao}
                    onChange={({ target }) => setEmailRecuperacao(target.value)}
                    style={{ maxWidth: '80%', margin: '0 auto' }}
                  />
                </div>
              )}

              {stepRecuperar === "codigo" && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <p>Digite o código de 6 caracteres enviado para o seu e-mail.</p>
                  <input
                    className={styles.inputs}
                    type="text"
                    name="codigoRecuperacao"
                    placeholder="Código de verificação"
                    value={codigoRecuperacao}
                    onChange={({ target }) => setCodigoRecuperacao(target.value.toUpperCase())}
                    maxLength={6}
                    style={{ maxWidth: '60%', margin: '0 auto' }}
                  />
                </div>
              )}

              {stepRecuperar === "novaSenha" && (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <p>Informe a nova senha de acesso.</p>
                  <input
                    className={styles.inputs}
                    type="password"
                    name="novaSenha"
                    placeholder="Nova senha"
                    value={novaSenha}
                    onChange={({ target }) => setNovaSenha(target.value)}
                    style={{ maxWidth: '80%', margin: '0 auto 8px' }}
                  />
                  <input
                    className={styles.inputs}
                    type="password"
                    name="confirmarNovaSenha"
                    placeholder="Confirmar nova senha"
                    value={confirmarNovaSenha}
                    onChange={({ target }) => setConfirmarNovaSenha(target.value)}
                    style={{ maxWidth: '80%', margin: '0 auto' }}
                  />
                </div>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={fecharModalRecuperacao}>
                Cancelar
              </Button>
              {stepRecuperar === "email" && (
                <Button variant="primary" onClick={handleEnviarEmailRecuperacao} disabled={loadingRecuperacao}>
                  {!loadingRecuperacao ? "Enviar código" : "Enviando..."}
                </Button>
              )}
              {stepRecuperar === "codigo" && (
                <Button variant="primary" onClick={handleValidarCodigo} disabled={loadingRecuperacao}>
                  {!loadingRecuperacao ? "Validar código" : "Validando..."}
                </Button>
              )}
              {stepRecuperar === "novaSenha" && (
                <Button variant="primary" onClick={handleConfirmarNovaSenha} disabled={loadingRecuperacao}>
                  {!loadingRecuperacao ? "Confirmar nova senha" : "Salvando..."}
                </Button>
              )}
            </Modal.Footer>
          </Modal>
        </form>
    )}

export default Login;